module.exports = __webpack_public_path__ + "static/media/resend_icon.faa2e43d.svg";